import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getParametros, updateParametro } from "../../Services/param_service";
import { setToast } from "../uiSlice";
import { setResponse } from "../Response/responseSlice";
import { UploadFileS3 } from "Slices/File/fileSlice";
import { fileUri } from "Constantes/constants";

const initialState = {
    parametros: [],
    parametrosImagenes: [],
    parametro: {},
}

export const parametroSlice = createSlice({
    name: 'parametros',
    initialState,
    reducers: {
        setParametros: (state, action) => {
            state.parametros = action.payload;
        },
        setParametrosImagenes: (state, action) => {
            state.parametrosImagenes = action.payload;
        },
        setParametro: (state, action) => {
            state.parametro = action.payload;
        },
        updateParametroField: (state, action) => {
            const { name, value } = action.payload;
            state.parametro[name] = value;
        },
    }
});

export const fetchParametros = createAsyncThunk(
    'parametros/fetchParametros',
    async (data, { dispatch }) => {
        const parametrosRes = await getParametros(data);
        if (data.files) {
            dispatch(setParametrosImagenes(parametrosRes ?? []));
            return;
        }
        await dispatch(setParametros(parametrosRes ?? {}));
    }
);


export const EditParametro = createAsyncThunk(
    'parametros/update',
    async (data, { dispatch }) => {
        const parametroRes = await updateParametro(data);
        
        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file);
            formData.append('tipo', fileUri.portada);
            await dispatch(UploadFileS3(formData));
        }
        
        dispatch(setResponse(parametroRes));
        dispatch(setToast(true));
        dispatch(fetchParametros({ tipo: data.tipo, files: data.files }));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setParametros, setParametrosImagenes, setParametro, updateParametroField } = parametroSlice.actions;
export default parametroSlice.reducer;